import React from 'react'

import HomePage from './HomePage'
// import './Home.css'

import { Row, Col } from 'antd';
import TextAppLink from './TextAppLink'
import Card, { CardHeader } from '../core/Card'

export const AppBanner = () =>
  <Card className="AppBanner">
      <CardHeader
        title="Effortless expense tracking"
      />
      <p style={{fontSize: "18px"}}>The Everlance app is available on the Apple App Store and Google Play Store.</p>
    <Row className="app-store-buttons" type="flex" justify="center" align="middle">
      <Col style={{textAlign: "center"}} xs={12} sm={12}>
        <img target="_blank" href="https://bnc.lt/E9ac/f8FS4VM8bw" className="app-store-button" src="https://s3.amazonaws.com/cdn.everlance.com/images/dashboard/app-store-button.png" />
        </Col>
      <Col style={{textAlign: "center"}} xs={12} sm={12}>
        <img  target="_blank" href="https://play.google.com/store/apps/details?id=com.everlance&hl=en" className="google-play-button" src="https://s3.amazonaws.com/cdn.everlance.com/images/dashboard/google-play-button.png" />
      </Col>
    </Row>
  </Card>

export const TextAppBanner = () =>
  <Card className="TextAppBanner">
    <CardHeader
      title="Download the App"
    />
    <TextAppLink />
  </Card>



// WEBPACK FOOTER //
// ./src/home/index.js